import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-report-icon',
  template: `
    <svg
      width="22"
      height="27"
      viewBox="0 0 22 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33333 18.6667H16V21.3333H5.33333V18.6667ZM5.33333 13.3333H16V16H5.33333V13.3333ZM13.3333 0H2.66667C1.2 0 0 1.2 0 2.66667V24C0 25.4667 1.18667 26.6667 2.65333 26.6667H18.6667C20.1333 26.6667 21.3333 25.4667 21.3333 24V8L13.3333 0ZM18.6667 24H2.66667V2.66667H12V9.33333H18.6667V24Z"
        fill="white"
      />
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportIconComponent {}
